import { RadioButton, Typography } from '@weareopenr/component-library';
import classnames from 'classnames/bind';
import { Control, Controller, UseFormRegister } from 'react-hook-form';
import { IRange } from 'src/api/getRanges';
import { ICreateTimetableFormValues } from '../types';
import { RangesField } from './RangesField';
import styles from './MenuSourceField.module.scss';

const cx = classnames.bind(styles);

interface MenuSourceFieldProps {
  register: UseFormRegister<any>;
  control: Control<ICreateTimetableFormValues>;
  isRangesSource: boolean;
  rangesEnabled: boolean;
  ranges: IRange[];
  isRangesLoading: boolean;
}

export const MenuSourceField = ({
  register,
  control,
  isRangesSource,
  rangesEnabled,
  ranges,
  isRangesLoading,
}: MenuSourceFieldProps) => (
  <div className={cx('container')}>
    <Typography size="medium" weight="bold">
      Menu Source:
    </Typography>
    <div className={cx('radios')}>
      <RadioButton name="menuSource" value="all" register={register}>
        <Typography weight="bold" size="medium">
          All Menus
        </Typography>
      </RadioButton>
      {rangesEnabled && (
        <RadioButton name="menuSource" value="ranges" register={register}>
          <Typography weight="bold" size="medium">
            Use defined Ranges
          </Typography>
        </RadioButton>
      )}
      {isRangesSource && (
        <Controller
          control={control}
          name="rangeIds"
          rules={{ validate: (value) => value.length > 0 || 'Please select at least one range' }}
          render={({ field, fieldState: { error } }) => (
            <RangesField
              ranges={ranges}
              isLoading={isRangesLoading}
              value={field.value}
              onChange={field.onChange}
              error={error?.message}
            />
          )}
        />
      )}
    </div>
  </div>
);

export default MenuSourceField;
